import config from '../config';
import {
  authHeader,
  customFetch,
  jsonHeader,
  handleResponse,
  commonRequestOptions,
} from '../helpers';

const endpointPath = config.api.API_URL + '/custom_property_value';

export const customPropertyValueService = {
  getByObjectId,
  destroy,
};

function getByObjectId(objectName, objectId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/get_by_object_id/${objectName}/${objectId}`,
    requestOptions,
    signal
  ).then(handleResponse);
}

function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}
